// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"lC","header":"lD","description":"lE","cta":"lF"};